import { getRouteApi } from "@tanstack/react-router";
import { useMemo } from "react";
import { REPORT_ITEMS, Reports } from "../overview/reports";

export function FamilyReportsSection() {
  const route = getRouteApi("/(auth)/_headed/clients/families/$id");
  const { family } = route.useLoaderData();
  const router = route.useNavigate();

  const reports = useMemo(() => {
    return REPORT_ITEMS.map((report) => ({
      label: report.label,
      icon: report.icon,
      onClick: () => {
        if (report.modal === "capital-gains") {
          router({
            to: ".",
            search: (prev) => ({
              ...prev,
              modal: "capital-gains",
              family_id: family.id,
            }),
          });
          return;
        }

        if (report.modal === "change-of-broker") {
          router({
            to: ".",
            search: (prev) => ({
              ...prev,
              modal: "change-of-broker",
              family_id: family.id,
            }),
          });
          return;
        }

        if (report.modal === "portfolio-valuation") {
          router({
            to: ".",
            search: (prev) => ({
              ...prev,
              modal: "portfolio-valuation",
              family_id: family.id,
            }),
          });
        }
      },
    }));
  }, [family.id, router]);

  if (!reports.length) return null;

  return <Reports reports={reports} />;
}
